export default class EventConsumer {
  constructor() {
    this._handlers = []
  }

  notify(event) {
    const handler = this._handlers[event.name];
    if (handler) {
      handler.call(this, event);
    }
  }

  on(eventName, handler) {
    this._handlers[eventName] = handler;
  }
}
